"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SsmlFormatterBase_1 = require("./SsmlFormatterBase");
var MicrosoftAzureSsmlFormatter = /** @class */ (function (_super) {
    __extends(MicrosoftAzureSsmlFormatter, _super);
    function MicrosoftAzureSsmlFormatter(options) {
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.modifierKeyToSsmlTagMappings.emphasis = 'emphasis';
        _this.modifierKeyToSsmlTagMappings.address = 'say-as';
        _this.modifierKeyToSsmlTagMappings.number = 'say-as';
        _this.modifierKeyToSsmlTagMappings.characters = 'say-as';
        _this.modifierKeyToSsmlTagMappings.expletive = null;
        _this.modifierKeyToSsmlTagMappings.fraction = 'say-as';
        _this.modifierKeyToSsmlTagMappings.interjection = null;
        _this.modifierKeyToSsmlTagMappings.ordinal = 'say-as';
        _this.modifierKeyToSsmlTagMappings.telephone = 'say-as';
        _this.modifierKeyToSsmlTagMappings.unit = null;
        _this.modifierKeyToSsmlTagMappings.time = 'say-as';
        _this.modifierKeyToSsmlTagMappings.date = 'say-as';
        _this.modifierKeyToSsmlTagMappings.sub = 'sub';
        _this.modifierKeyToSsmlTagMappings.paragraph = 'p';
        _this.modifierKeyToSsmlTagMappings.sentence = 's';
        _this.modifierKeyToSsmlTagMappings.lang = 'lang';
        _this.modifierKeyToSsmlTagMappings.voice = 'voice';
        // Phoneme attributes
        _this.modifierKeyToSsmlTagMappings.ipa = 'phoneme';
        _this.modifierKeyToSsmlTagMappings.sapi = 'phoneme';
        _this.modifierKeyToSsmlTagMappings.ups = 'phoneme';
        // Prosody attributes
        _this.modifierKeyToSsmlTagMappings.pitch = 'prosody';
        _this.modifierKeyToSsmlTagMappings.contour = 'prosody';
        _this.modifierKeyToSsmlTagMappings.range = 'prosody';
        _this.modifierKeyToSsmlTagMappings.rate = 'prosody';
        _this.modifierKeyToSsmlTagMappings.volume = 'prosody';
        _this.modifierKeyToSsmlTagMappings.whisper = 'prosody';
        // mstts specifics
        _this.modifierKeyToSsmlTagMappings.emotion = 'mstts:express-as';
        _this.ssmlTagSortOrder = [
            'voice',
            'lang',
            'p',
            's',
            'emphasis',
            'say-as',
            'mstts:express-as',
            'prosody',
            'sub',
            'phoneme'
        ];
        return _this;
    }
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getTextModifierObject = function (ast) {
        var textModifierObject = new SsmlFormatterBase_1.TagsObject(this);
        for (var index = 0; index < ast.children.length; index++) {
            var child = ast.children[index];
            switch (child.name) {
                case 'plainText':
                case 'plainTextSpecialChars':
                case 'plainTextEmphasis':
                case 'plainTextPhone':
                case 'plainTextModifier': {
                    textModifierObject['text'] = child.allText;
                    break;
                }
                case 'textModifierKeyOptionalValue': {
                    var key = child.children[0].allText;
                    key = this.modifierKeyMappings[key] || key;
                    var value = child.children.length === 2 ? child.children[1].allText : '';
                    var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                    switch (key) {
                        case 'address':
                        case 'fraction':
                        case 'ordinal':
                        case 'telephone':
                            textModifierObject.tag(ssmlTag, { 'interpret-as': key }, false, this.ssmlTagSortOrder);
                            break;
                        case "number":
                            textModifierObject.tag(ssmlTag, { 'interpret-as': 'cardinal' }, false, this.ssmlTagSortOrder);
                            break;
                        case "characters": {
                            var attrValue = 'digits';
                            if (isNaN(textModifierObject.text)) {
                                attrValue = 'characters';
                            }
                            textModifierObject.tag(ssmlTag, { 'interpret-as': attrValue }, false, this.ssmlTagSortOrder);
                            break;
                        }
                        case 'date':
                            textModifierObject.tag(ssmlTag, { 'interpret-as': key, format: value || 'ymd' }, false, this.ssmlTagSortOrder);
                            break;
                        case 'time':
                            textModifierObject.tag(ssmlTag, { 'interpret-as': key, format: value || 'hms12' }, false, this.ssmlTagSortOrder);
                            break;
                        case 'whisper':
                            textModifierObject.tag(ssmlTag, { volume: 'x-soft', rate: 'slow' }, false, this.ssmlTagSortOrder);
                            break;
                        case 'ipa':
                        case 'sapi':
                        case 'ups':
                            textModifierObject.tag(ssmlTag, { alphabet: key, ph: value }, false, this.ssmlTagSortOrder);
                            break;
                        case 'sub':
                            textModifierObject.tag(ssmlTag, { alias: value }, false, this.ssmlTagSortOrder);
                            break;
                        case 'volume':
                        case 'rate':
                        case 'pitch': {
                            var attrs = {};
                            attrs[key] = value || 'medium';
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        }
                        case 'lang':
                            textModifierObject.tag(ssmlTag, { 'xml:lang': value }, false, this.ssmlTagSortOrder);
                            break;
                        case 'voice': {
                            // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                            // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                            var name = this.sentenceCase(value || 'device');
                            if (name != 'Device') {
                                textModifierObject.tag(ssmlTag, { 'name': name }, false, this.ssmlTagSortOrder);
                            }
                            break;
                        }
                        case 'emotion': {
                            // The 'value' field can contain up to 2 data, separated by a space. Let's explode the value string
                            var attrsArray = value.split(' ');
                            var attrs = {};
                            // In order, we get 'style' first, then 'styledegree' or 'role' from the value
                            switch (attrsArray.length) {
                                case 2:
                                    var parsed = parseInt(attrsArray[1]);
                                    // If the result is a number, it's the 'styledegree' attribute, either way it's the 'role' one
                                    if (isNaN(parsed)) {
                                        attrs['role'] = attrsArray[1];
                                    }
                                    else {
                                        attrs['styledegree'] = attrsArray[1];
                                    }
                                case 1:
                                    attrs['style'] = attrsArray[0];
                                    break;
                                default:
                                    break;
                            }
                            textModifierObject.tag(ssmlTag, attrs, true, this.ssmlTagSortOrder);
                            break;
                        }
                        case 'emphasis':
                            textModifierObject.tag(ssmlTag, { 'level': value }, false, this.ssmlTagSortOrder);
                            break;
                        case 'paragraph':
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        case 'sentence':
                            textModifierObject.tag(ssmlTag, null, false, this.ssmlTagSortOrder);
                            break;
                        default: {
                        }
                    }
                    break;
                }
            }
        }
        return textModifierObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.getSectionObject = function (ast) {
        var sectionObject = new SsmlFormatterBase_1.TagsObject(this);
        for (var index = 0; index < ast.children.length; index++) {
            var child = ast.children[index];
            if (child.name === 'sectionModifierKeyOptionalValue') {
                var key = child.children[0].allText;
                var value = child.children.length === 2 ? child.children[1].allText : '';
                var ssmlTag = this.modifierKeyToSsmlTagMappings[key];
                switch (key) {
                    case 'voice': {
                        // Voice name must be as follows (case insensitive, the examples give the common writing with case) :
                        // <language>-<CULTURE>-<VoiceName> (ex: en-US-GuyNeural, en-US-JennyNeural)
                        var name = this.sentenceCase(value || 'device');
                        if (name != 'Device') {
                            sectionObject.tag(ssmlTag, { 'name': name }, false, this.ssmlTagSortOrder);
                        }
                        break;
                    }
                    case 'defaults': {
                        break;
                    }
                    case 'emotion':
                        sectionObject.tag(ssmlTag, { 'style': value }, false, this.ssmlTagSortOrder);
                        break;
                    default: {
                    }
                }
            }
        }
        return sectionObject;
    };
    // tslint:disable-next-line: max-func-body-length
    MicrosoftAzureSsmlFormatter.prototype.formatFromAst = function (ast, lines) {
        if (lines === void 0) { lines = []; }
        switch (ast.name) {
            case 'document': {
                if (this.options.includeFormatterComment) {
                    this.addComment('Converted from Speech Markdown to SSML for Microsoft Azure', lines);
                }
                if (this.options.includeSpeakTag) {
                    return this.addSpeakTag(ast.children, true, false, null, lines);
                }
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            }
            case 'paragraph': {
                if (this.options.includeParagraphTag) {
                    return this.addTag('p', ast.children, true, false, null, lines);
                }
                else {
                    this.processAst(ast.children, lines);
                    return lines;
                }
            }
            case 'shortBreak': {
                var time = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, 'break', { time: time });
            }
            case 'break': {
                var val = ast.children[0].allText;
                var attrs = {};
                switch (ast.children[0].children[0].name) {
                    case 'breakStrengthValue':
                        attrs = { strength: val };
                        break;
                    case 'time':
                        attrs = { time: val };
                        break;
                }
                return this.addTagWithAttrs(lines, null, 'break', attrs);
            }
            case 'silence': {
                // 2 attributes, space-separated : type and value
                // type can be : Leading, Tailing or Sentenceboundary
                // value in seconds or milliseconds (ex : 1s, 200ms) less than 5 seconds
                var attrsArray = ast.children[0].allText.split(' ');
                var attrs = {
                    'type': attrsArray[0],
                    'value': attrsArray[1]
                };
                return this.addTagWithAttrs(lines, null, 'mstts:silence', attrs);
            }
            case 'backgroundAudio': {
                // 1 to 4 attributes, space-separated : src (mandatory), volume, fadein, fadeout
                var attrsArray = ast.children[0].allText.split(' ');
                var attrs = {};
                var attributes = ['src', 'volume', 'fadein', 'fadeout'];
                for (var i = 0; i < attrsArray.length; i++) {
                    attrs[attributes[i]] = attrsArray[i];
                }
                return this.addTagWithAttrs(lines, null, 'mstts:backgroundaudio', attrs);
            }
            case 'lexicon': {
                var uri = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, 'lexicon', { uri: uri });
            }
            case 'bookmark': {
                var mark = ast.children[0].allText;
                return this.addTagWithAttrs(lines, null, 'bookmark', { mark: mark });
            }
            case 'shortEmphasisModerate':
            case 'shortEmphasisStrong':
            case 'shortEmphasisNone':
            case 'shortEmphasisReduced': {
                var text = ast.children[0].allText;
                if (text) {
                    lines.push(text);
                }
                return lines;
            }
            case 'textModifier': {
                var tmo_1 = this.getTextModifierObject(ast);
                var tagsSortedDesc = Object.keys(tmo_1.tags).sort(function (a, b) { return tmo_1.tags[b].sortId - tmo_1.tags[a].sortId; });
                var inner = tmo_1.text;
                for (var index = 0; index < tagsSortedDesc.length; index++) {
                    var tag = tagsSortedDesc[index];
                    var attrs = tmo_1.tags[tag].attrs;
                    if (tag === 'voice' || tag === 'lang') {
                        var previousTag = index < tagsSortedDesc.length - 1 ? tagsSortedDesc[index + 1] : '';
                        inner = this.getVoiceOrLangTagWithAttrs(inner, tag, attrs, previousTag);
                    }
                    else {
                        inner = this.getTagWithAttrs(inner, tag, attrs);
                    }
                }
                lines.push(inner);
                return lines;
            }
            case 'audio': {
                var url = ast.children[0].allText.replace(/&/g, '&amp;');
                return this.addTagWithAttrs(lines, null, 'audio', { src: url }, false);
            }
            case 'simpleLine': {
                this.processAst(ast.children, lines);
                return lines;
            }
            case 'lineEnd': {
                lines.push(ast.allText);
                return lines;
            }
            case 'emptyLine': {
                if (this.options.preserveEmptyLines) {
                    lines.push(ast.allText);
                }
                return lines;
            }
            case 'plainText':
            case 'plainTextSpecialChars':
            case 'plainTextEmphasis':
            case 'plainTextPhone':
            case 'plainTextModifier': {
                lines.push(ast.allText);
                return lines;
            }
            case 'section': {
                var so_1 = this.getSectionObject(ast);
                var tagsSortedAsc = Object.keys(so_1.tags).sort(function (a, b) { return so_1.tags[a].sortId - so_1.tags[b].sortId; });
                this.addSectionEndTag(lines);
                this.addSectionStartTag(tagsSortedAsc, so_1, lines);
                return lines;
            }
            default: {
                this.processAst(ast.children, lines);
                return lines;
            }
        }
    };
    MicrosoftAzureSsmlFormatter.prototype.getVoiceOrLangTagWithAttrs = function (text, tag, attrs, previousTag) {
        var lines = [];
        if (text) {
            lines.push(this.startVoiceOrLangTag(tag, attrs, previousTag));
            lines.push(text);
            lines.push(this.endVoiceOrLangTag(tag, false, previousTag));
        }
        else {
            lines.push(this.voidTag(tag, attrs));
        }
        return lines.join('');
    };
    // Returns the SSML for a start tag
    MicrosoftAzureSsmlFormatter.prototype.startVoiceOrLangTag = function (tag, attr, previousTag, newLine) {
        if (newLine === void 0) { newLine = false; }
        var attrStr = '';
        var prefix = '';
        switch (tag) {
            case 'voice':
                // If a global 'voice' tag is opened at the root of the SSML file, we have to close it and re-open it every time another 'voice' tag opens
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    prefix = '</voice>';
                    // If there is a global lang, let's open a new tag for this lang
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) {
                        prefix = '</lang>' + prefix;
                    }
                }
                break;
            case 'lang':
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === 'voice')) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) {
                        prefix = '</lang>';
                    }
                }
                break;
            default:
                break;
        }
        if (attr) {
            attrStr = ' ' + Object.keys(attr).map(function (k) {
                return k + '="' + attr[k] + '"';
            }).join(' ');
        }
        return prefix + '<' + tag + attrStr + '>' + (newLine ? '\n' : '');
    };
    // Returns the SSML for an end tag
    MicrosoftAzureSsmlFormatter.prototype.endVoiceOrLangTag = function (tag, newLine, previousTag) {
        if (newLine === void 0) { newLine = false; }
        var suffix = '';
        switch (tag) {
            case 'voice':
                // If a global 'voice' tag is opened at the root of the SSML file, we have to re-open it every time another 'voice' tag ends
                if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice) {
                    suffix = "<voice name=\"" + this.options.globalVoiceAndLang.voice + "\">";
                    // If a global 'lang' tag is opened at the root of the SSML file, we have to re-open it every time a 'voice' tag ends
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang) {
                        suffix += "<lang xml:lang=\"" + this.options.globalVoiceAndLang.lang + "\">";
                    }
                }
                break;
            case 'lang':
                // If the previous tag was a 'voice' one, we use the basic behaviour
                if (!(previousTag && previousTag === 'voice')) {
                    if (this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && tag === 'lang') {
                        suffix = "<lang xml:lang=\"" + this.options.globalVoiceAndLang.lang + "\">";
                    }
                }
                break;
            default:
                break;
        }
        return (newLine ? '\n' : '') + '</' + tag + '>' + suffix;
    };
    return MicrosoftAzureSsmlFormatter;
}(SsmlFormatterBase_1.SsmlFormatterBase));
exports.MicrosoftAzureSsmlFormatter = MicrosoftAzureSsmlFormatter;
//# sourceMappingURL=MicrosoftAzureSsmlFormatter.js.map